import { Action } from '@ngrx/store';
import { UserVaultFolders } from './vault.model';

export enum ActionTypes {
  GET_VAULT_REQUEST = '[GET_VAULT] Request',
  GET_VAULT_SUCCESS = '[GET_VAULT] Success',
  GET_VAULT_FAILURE = '[GET_VAULT] FAilure',
  SET_VAULT_SUCCESS = '[SET_VAULT] Success',

  // GET_VAULT_FAILURE = '[GET_VAULT] Failure',

  USER_FOLDERS_COMPLETE = '[VAULT] User Folders Complete',
  USER_FOLDERS_REQUEST = '[VAULT] User Folders Request',
  USER_FOLDERS_FAILURE = '[VAULT] User Folders Failure',

  REMOVE_DEFAULT_FOLDER_COMPLETE = '[VAULT] Remove Default Folder Complete',
  REMOVE_DEFAULT_FOLDER_REQUEST = '[VAULT] Remove Default Folder Request',
  REMOVE_DEFAULT_FOLDER_FAILURE = '[VAULT] Remove Default Folder Failure',

  ADD_DEFAULT_FOLDER_COMPLETE = '[VAULT] Add Default Folder Complete',
  ADD_DEFAULT_FOLDER_REQUEST = '[VAULT] Add Default Folder Request',
  ADD_DEFAULT_FOLDER_FAILURE = '[VAULT] Add Default Folder Failure',

  USER_FOLDER_FILES_REQUEST = '[VAULT] User Folder Files Request',
  USER_FOLDER_FILES_COMPLETE = '[VAULT] User Folder Files Complete',

  REMOVE_DEFAULT_FOLDER_FILE = '[VAULT] Remove Default Folder File Complete',
  REMOVE_DEFAULT_FOLDER_FILE_FAILURE = '[VAULT] Remove Default Folder File Failure',
  USER_FOLDER_FILES_REQUEST_CLEAR = '[VAULT] user Folder Files Request clear',

  PERSONAL_FOLDER_FILES_REQUEST_CLEAR = '[VAULT] Personal Folder Files Request clear',
  PERSONAL_FOLDER_FILES_REQUEST_RESET = '[VAULT] Personal Folder Files Request reset',
  PERSONAL_FOLDER_FILES_REQUEST = '[VAULT] Personal Folder Files Request',
  PERSONAL_FOLDER_FILES_COMPLETE = '[VAULT] Personal Folder Files Complete',
  PERSONAL_FOLDER_FILES_FAILURE = '[VAULT] Personal Folder Files Failure',

  MOVE_FILE_TO_FOLDER_COMPLETE = '[VAULT] Move file to Folder Complete',
  MOVE_FILE_TO_FOLDER_REQUEST = '[VAULT] Move file to Folder Request',
  MOVE_FILE_TO_FOLDER_FAILURE = '[VAULT] Move file to Folder Failure',

  SHARED_DATA_WITH_ME_REQUEST = '[VAULT] Shared with me Request',
  SHARED_DATA_WITH_ME_COMPLETE = '[VAULT] Shared with me Complete',
  SHARED_DATA_WITH_ME_FAILURE = '[VAULT] Shared with me Failure',

  SHARED_DATA_BY_ME_REQUEST = '[VAULT] Shared by me Request',
  SHARED_DATA_BY_ME_COMPLETE = '[VAULT] Shared by me Complete',
  SHARED_DATA_BY_ME_FAILURE = '[VAULT] Shared by me Failure',

  SHARED_FILES_IN_FOLDERS_WITH_ME_REQUEST = '[VAULT] Shared files with me Request',
  SHARED_FILES_IN_FOLDERS_WITH_ME_COMPLETE = '[VAULT] Shared files with me Complete',
  SHARED_FILES_IN_FOLDERS_WITH_ME_FAILURE = '[VAULT] Shared files with me Failure',

  DELETE_FOLDER_COMPLETE = '[VAULT] Delete Folder Complete',
  DELETE_FOLDER_REQUEST = '[VAULT] Delete Folder Request',
  DELETE_FOLDER_FAILURE = '[VAULT] Delete Folder Complete',

  DELETE_FILE_COMPLETE = '[VAULT] Delete File Complete',
  DELETE_FILE_REQUEST = '[VAULT] Delete File Request',
  DELETE_FILE_FAILURE = '[VAULT] Delete File Failure',

  ADMIN_ACCESS_REQUEST = '[VAULT] Admin Access Request',
  ADMIN_ACCESS_COMPLETE = '[VAULT] Admin Access Complete',
  ADMIN_ACCESS_FAILURE = '[VAULT] Admin Access Failure',

  FORMS_REQUEST = '[VAULT] Forms Request',
  FORMS_COMPLETE = '[VAULT] Forms Complete',
  FORMS_FAILURE = '[VAULT] Forms Failure',

  DEFAULT_FOLDER_REQUEST_CLEAR = '[VAULT] Default Folder Request clear',
  DEFAULT_FOLDER_REQUEST = '[VAULT] Default Folder Request',
  DEFAULT_FOLDER_COMPLETE = '[VAULT] Default Folder Complete',
  DEFAULT_FOLDER_FAILURE = '[VAULT] Default Folder Failure',

  CATEGORIES_REQUEST = '[VAULT] Categories Request',
  CATEGORIES_COMPLETE = '[VAULT] Categories Complete',
  CATEGORIES_FAILURE = '[VAULT] Categories Failure',

  VAULT_STATS_REQUEST = '[VAULT-STATS]  Request',
  VAULT_STATS_COMPLETE = '[VAULT-STATS] Request Complete',
  VAULT_STATS_FAILURE = '[VAULT-STATS] Request Failure',

  OFFICE_STATS_REQUEST = '[OFFICE-STATS]  Request',
  OFFICE_STATS_COMPLETE = '[OFFICE-STATS] Request Complete',
  OFFICE_STATS_FAILURE = '[OFFICE-STATS] Request Failure',

  USER_FOLDERS_SHARED_WITH_ME_COMPLETE = '[VAULT] USER FOLDERS SHARED WITH ME Complete',
  USER_FOLDERS_SHARED_WITH_ME_REQUEST = '[VAULT] USER FOLDERS SHARED WITH ME Request',
  USER_FOLDERS_SHARED_WITH_ME_FAILURE = '[VAULT] USER FOLDERS SHARED WITH ME Failure',

  USER_FOLDERS_SHARED_BY_ME_COMPLETE = '[VAULT] USER FOLDERS SHARED By ME Complete',
  USER_FOLDERS_SHARED_BY_ME_REQUEST = '[VAULT] USER FOLDERS SHARED BY ME Request',
  USER_FOLDERS_SHARED_BY_ME_FAILURE = '[VAULT] USER FOLDERS SHARED BY ME Failure',

  VAULT_STATS_RESET_FOLDER_REQUEST = '[VAULT] STATE RESET FOLDERS REQUEST',
  VAULT_RESET_REQUEST = '[VAULT] VAULT RESET REQUEST',
}

export class GetVaultRequestAction implements Action {
  readonly type = ActionTypes.GET_VAULT_REQUEST;
  constructor(public userId: number | string, public loader: boolean) {}
}

export class GetVaultSuccessAction implements Action {
  readonly type = ActionTypes.GET_VAULT_SUCCESS;
  constructor(public payload: any) {}
}

export class GetVaultFailureAction implements Action {
  readonly type = ActionTypes.GET_VAULT_FAILURE;
  constructor(public payload: any) {}
}
export class SetVaultSuccessAction implements Action {
  readonly type = ActionTypes.SET_VAULT_SUCCESS;
  constructor(public vaultId: number, public vaultName: string) {}
}

// export class GetVaultFailureAction implements Action {
//   readonly type = ActionTypes.GET_VAULT_FAILURE;
// }

export class UserFoldersAction implements Action {
  readonly type = ActionTypes.USER_FOLDERS_COMPLETE;
  constructor(public payload: UserVaultFolders) {}
}

export class UserFoldersFailureAction implements Action {
  readonly type = ActionTypes.USER_FOLDERS_FAILURE;
  constructor(public payload: any) {}
}

export class UserFoldersSharedWithMeRequest implements Action {
  readonly type = ActionTypes.USER_FOLDERS_SHARED_WITH_ME_REQUEST;
  constructor(public userId: number, public loader: boolean) {}
}
export class UserFoldersSharedByMeRequest implements Action {
  readonly type = ActionTypes.USER_FOLDERS_SHARED_BY_ME_REQUEST;
  constructor(public userId: number, public loader: boolean, public vaultId: number) {}
}

export class UserFoldersSharedWithMeAction implements Action {
  readonly type = ActionTypes.USER_FOLDERS_SHARED_WITH_ME_COMPLETE;
  constructor(public payload: any) {}
}

export class UserFoldersSharedWithMeFailureAction implements Action {
  readonly type = ActionTypes.USER_FOLDERS_SHARED_WITH_ME_FAILURE;
  constructor(public payload: any) {}
}

export class UserFoldersSharedByMeAction implements Action {
  readonly type = ActionTypes.USER_FOLDERS_SHARED_BY_ME_COMPLETE;
  constructor(public payload: any) {}
}

export class UserFoldersRequest implements Action {
  readonly type = ActionTypes.USER_FOLDERS_REQUEST;
  constructor(
    public userId: number | string,
    public loader: boolean,
    public vaultId: any = null,
    public myData: boolean = false,
    public w_id: any = null
  ) {}
}

export class RemoveDefaultFolderAction implements Action {
  readonly type = ActionTypes.REMOVE_DEFAULT_FOLDER_COMPLETE;
  constructor(public payload: any) {}
}

export class RemoveDefaultFolderFailureAction implements Action {
  readonly type = ActionTypes.REMOVE_DEFAULT_FOLDER_FAILURE;
  constructor(public payload: any) {}
}

export class RemoveDefaultFolderRequest implements Action {
  readonly type = ActionTypes.REMOVE_DEFAULT_FOLDER_REQUEST;
  constructor(public payload: any) {}
}

export class AddDefaultFolderAction implements Action {
  readonly type = ActionTypes.ADD_DEFAULT_FOLDER_COMPLETE;
  constructor(public payload: any) {}
}
export class AddDefaultFolderFailureAction implements Action {
  readonly type = ActionTypes.ADD_DEFAULT_FOLDER_FAILURE;
  constructor(public payload: any) {}
}

export class AddDefaultFolderRequest implements Action {
  readonly type = ActionTypes.ADD_DEFAULT_FOLDER_REQUEST;
  constructor(public payload: any) {}
}
export class UserFolderFilesAction implements Action {
  readonly type = ActionTypes.USER_FOLDER_FILES_COMPLETE;
  constructor(public payload: any) {}
}

export class UserFolderFiles implements Action {
  readonly type = ActionTypes.USER_FOLDER_FILES_REQUEST;
  constructor(public payload: any) {}
}

export class RemoveDefaultFolderFileAction implements Action {
  readonly type = ActionTypes.REMOVE_DEFAULT_FOLDER_FILE;
  constructor(public payload: any) {}
}
export class RemoveDefaultFolderFileFailureAction implements Action {
  readonly type = ActionTypes.REMOVE_DEFAULT_FOLDER_FILE_FAILURE;
  constructor(public payload: any) {}
}

export class PersonalFolderFiles implements Action {
  readonly type = ActionTypes.PERSONAL_FOLDER_FILES_COMPLETE;
  constructor(public payload: any) {}
}

export class PersonalFolderFilesFailure implements Action {
  readonly type = ActionTypes.PERSONAL_FOLDER_FILES_FAILURE;
  constructor(public payload: any) {}
}

export class DefaultFolderRequestClear implements Action {
  readonly type = ActionTypes.DEFAULT_FOLDER_REQUEST_CLEAR;
  constructor() {}
}
export class PersonalFolderFilesRequestClear implements Action {
  readonly type = ActionTypes.PERSONAL_FOLDER_FILES_REQUEST_CLEAR;
  constructor() {}
}
export class PersonalFolderFilesRequestReset implements Action {
  readonly type = ActionTypes.PERSONAL_FOLDER_FILES_REQUEST_RESET;
  constructor() {}
}

export class UserFolderFilesRequestClear implements Action {
  readonly type = ActionTypes.USER_FOLDER_FILES_REQUEST_CLEAR;
  constructor() {}
}
export class PersonalFolderFilesRequest implements Action {
  readonly type = ActionTypes.PERSONAL_FOLDER_FILES_REQUEST;
  constructor(public payload: any) {}
}

export class MoveFileToFolderAction implements Action {
  readonly type = ActionTypes.MOVE_FILE_TO_FOLDER_COMPLETE;
  constructor(public payload: any) {}
}

export class MoveFileToFolderFailureAction implements Action {
  readonly type = ActionTypes.MOVE_FILE_TO_FOLDER_FAILURE;
  constructor(public payload: any) {}
}

export class MoveFiletoFolderRequest implements Action {
  readonly type = ActionTypes.MOVE_FILE_TO_FOLDER_REQUEST;
  constructor(public payload: any) {}
}

export class SharedDataWithMeAction implements Action {
  readonly type = ActionTypes.SHARED_DATA_WITH_ME_COMPLETE;
  constructor(public payload: any) {}
}

export class SharedDataWithMeFailureAction implements Action {
  readonly type = ActionTypes.SHARED_DATA_WITH_ME_FAILURE;
  constructor(public payload: any) {}
}

export class SharedDataWithMeRequest implements Action {
  readonly type = ActionTypes.SHARED_DATA_WITH_ME_REQUEST;
  constructor(public payload: any) {}
}

export class SharedDataByMeRequest implements Action {
  readonly type = ActionTypes.SHARED_DATA_BY_ME_REQUEST;
  constructor(public payload: any) {}
}

export class SharedDataByMeAction implements Action {
  readonly type = ActionTypes.SHARED_DATA_BY_ME_COMPLETE;
  constructor(public payload: any) {}
}

export class SharedDataByMeFailureAction implements Action {
  readonly type = ActionTypes.SHARED_DATA_BY_ME_FAILURE;
  constructor(public payload: any) {}
}

export class DeleteFolderAction implements Action {
  readonly type = ActionTypes.DELETE_FOLDER_COMPLETE;
  constructor(public payload: any) {}
}

export class DeleteFolderFailureAction implements Action {
  readonly type = ActionTypes.DELETE_FOLDER_FAILURE;
  constructor(public payload: any) {}
}

export class DeleteFolderRequest implements Action {
  readonly type = ActionTypes.DELETE_FOLDER_REQUEST;
  constructor(public payload: any) {}
}

export class DeleteFileAction implements Action {
  readonly type = ActionTypes.DELETE_FILE_COMPLETE;
  constructor(public payload: any) {}
}
export class DeleteFileFailureAction implements Action {
  readonly type = ActionTypes.DELETE_FILE_FAILURE;
  constructor(public payload: any) {}
}

export class DeleteFileRequest implements Action {
  readonly type = ActionTypes.DELETE_FILE_REQUEST;
  constructor(public payload: any) {}
}

export class AdminAccessAction implements Action {
  readonly type = ActionTypes.ADMIN_ACCESS_COMPLETE;
  constructor(public payload: any) {}
}
export class AdminAccessFailureAction implements Action {
  readonly type = ActionTypes.ADMIN_ACCESS_FAILURE;
  constructor(public payload: any) {}
}

export class AdminAccessRequest implements Action {
  readonly type = ActionTypes.ADMIN_ACCESS_REQUEST;
}

export class SharedFilesInFolderAction implements Action {
  readonly type = ActionTypes.SHARED_FILES_IN_FOLDERS_WITH_ME_COMPLETE;
  constructor(public payload: any) {}
}
export class SharedFilesInFolderFailureAction implements Action {
  readonly type = ActionTypes.SHARED_FILES_IN_FOLDERS_WITH_ME_FAILURE;
  constructor(public payload: any) {}
}

export class SharedFilesInFolderRequest implements Action {
  readonly type = ActionTypes.SHARED_FILES_IN_FOLDERS_WITH_ME_REQUEST;
  constructor(public payload: any) {}
}

export class FormAction implements Action {
  readonly type = ActionTypes.FORMS_COMPLETE;
  constructor(public payload: any) {}
}

export class FormFailureAction implements Action {
  readonly type = ActionTypes.FORMS_FAILURE;
  constructor(public payload: any) {}
}

export class FormRequest implements Action {
  readonly type = ActionTypes.FORMS_REQUEST;
}

export class DefaultFolderAction implements Action {
  readonly type = ActionTypes.DEFAULT_FOLDER_COMPLETE;
  constructor(public payload: any) {}
}

export class DefaultFolderFailureAction implements Action {
  readonly type = ActionTypes.DEFAULT_FOLDER_FAILURE;
  constructor(public payload: any) {}
}

export class DefaultFolderRequest implements Action {
  readonly type = ActionTypes.DEFAULT_FOLDER_REQUEST;
  constructor(public payload: any, public vaultId: any = null, public myData: boolean = false, public APi_verb: any = null) {}
}

export class CategoriesAction implements Action {
  readonly type = ActionTypes.CATEGORIES_COMPLETE;
  constructor(public payload: any) {}
}

export class CategoriesFailureAction implements Action {
  readonly type = ActionTypes.CATEGORIES_FAILURE;
  constructor(public payload: any) {}
}

export class CategoriesRequest implements Action {
  readonly type = ActionTypes.CATEGORIES_REQUEST;
}

export class vaultStateAction implements Action {
  readonly type = ActionTypes.VAULT_STATS_COMPLETE;
  constructor(public payload: any) {}
}

export class vaultStateFailureAction implements Action {
  readonly type = ActionTypes.VAULT_STATS_FAILURE;
  constructor(public payload: any) {}
}

export class officeStateAction implements Action {
  readonly type = ActionTypes.OFFICE_STATS_COMPLETE;
  constructor(public payload: any) {}
}
export class OfficeFailureAction implements Action {
  readonly type = ActionTypes.OFFICE_STATS_FAILURE;
  constructor(public payload: any) {}
}

export class vaultStateRequest implements Action {
  readonly type = ActionTypes.VAULT_STATS_REQUEST;
}
export class getOfficeStateRequest implements Action {
  readonly type = ActionTypes.OFFICE_STATS_REQUEST;
  constructor(public payload: any, public loader: boolean) {}
}

export class vaultStateResetFlderRequest implements Action {
  readonly type = ActionTypes.VAULT_STATS_RESET_FOLDER_REQUEST;
}
export class vaultResetRequest implements Action {
  readonly type = ActionTypes.VAULT_RESET_REQUEST;
}
export type Actions =
  | UserFolderFiles
  | UserFolderFilesAction
  | UserFoldersAction
  | UserFoldersFailureAction
  | UserFoldersRequest
  | AddDefaultFolderAction
  | AddDefaultFolderRequest
  | RemoveDefaultFolderAction
  | RemoveDefaultFolderRequest
  | RemoveDefaultFolderFailureAction
  | RemoveDefaultFolderFileAction
  | PersonalFolderFiles
  | PersonalFolderFilesRequestReset
  | PersonalFolderFilesRequest
  | PersonalFolderFilesRequestClear
  | UserFolderFilesRequestClear
  | DefaultFolderRequestClear
  | MoveFileToFolderAction
  | MoveFiletoFolderRequest
  | SharedDataWithMeAction
  | SharedDataWithMeRequest
  | SharedDataByMeRequest
  | SharedDataByMeAction
  | SharedDataByMeFailureAction
  | DeleteFileRequest
  | DeleteFileAction
  | DeleteFolderRequest
  | DeleteFolderAction
  | AdminAccessAction
  | AdminAccessRequest
  | SharedFilesInFolderAction
  | SharedFilesInFolderRequest
  | FormAction
  | FormRequest
  | DefaultFolderAction
  | AddDefaultFolderFailureAction
  | RemoveDefaultFolderFileFailureAction
  | DefaultFolderRequest
  | CategoriesAction
  | CategoriesRequest
  | vaultStateAction
  | vaultStateRequest
  | officeStateAction
  | OfficeFailureAction
  | getOfficeStateRequest
  | UserFoldersSharedWithMeRequest
  | UserFoldersSharedWithMeAction
  | UserFoldersSharedWithMeFailureAction
  | UserFoldersSharedByMeAction
  | UserFoldersSharedByMeRequest
  | vaultStateResetFlderRequest
  | GetVaultRequestAction
  | GetVaultSuccessAction
  | GetVaultFailureAction
  | SetVaultSuccessAction
  | PersonalFolderFilesFailure
  | MoveFileToFolderFailureAction
  | SharedDataWithMeFailureAction
  | DeleteFileFailureAction
  | DeleteFolderFailureAction
  | AdminAccessFailureAction
  | SharedFilesInFolderFailureAction
  | FormFailureAction
  | DefaultFolderFailureAction
  | CategoriesFailureAction
  | vaultStateFailureAction
  | vaultResetRequest;
